import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface OnboardingState {
  visible: boolean
}

const initialState: OnboardingState = { visible: false }

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setOnboardingVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload
    },
  },
})

export const { setOnboardingVisible } = onboardingSlice.actions
export default onboardingSlice.reducer
